<div class="container mt-4">
  <chapps-header [label]="Localization.Feedback"></chapps-header>
  <div class="mt-4">
    <chapps-text-area-input [label]="Localization.FeedbackMessage" [rows]="10" [control]="feedbackFormControl">
    </chapps-text-area-input>
  </div>
  <div class="d-flex justify-content-end">
    <chapps-success-button [label]="Localization.Send | translate" [small]="true"
      [disabled]="feedbackFormControl.value == null" [loading]="isActionInProgress" (clicked)="onSubmit()">
    </chapps-success-button>
  </div>
</div>
<div mdbModal #modalFeedbackSubmitted="mdbModal" class="modal fade" id="modalFeedbackSubmitted" tabindex="-1" role="dialog">
  <div class="modal-dialog cascading-modal" role="document">
    <div class="modal-content">
      <div class="modal-body mt-3">
        {{ Localization.FeedbackSubmitted | translate }}
        <div class="d-flex justify-content-between mt-4 mb-3">
          <button type="button" class="btn btn-sm btn-grey" (click)="modalFeedbackSubmitted.hide()" mdbRippleRadius>{{ Localization.Close | translate }}</button>
        </div>
      </div>
    </div>
  </div>
</div>